import { Download } from 'lucide-react'
import type { Attachment } from '../lib/types'
import { formatBytes } from '../lib/format'
import { FileGlyph } from './FileGlyph'

// Вложения готового комментария: сетка картинок (клик → лайтбокс) + файлы-чипы (скачивание).
export function AttachmentList({
  attachments,
  onOpenImage
}: {
  attachments: Attachment[]
  onOpenImage: (url: string) => void
}) {
  if (!attachments.length) return null

  const images = attachments.filter((item) => item.isImage)
  const files = attachments.filter((item) => !item.isImage)

  return (
    <div className="attachments">
      {images.length > 0 && (
        <div className="attachments-grid">
          {images.map((item) => (
            <button
              type="button"
              key={item.id}
              className="attachment-image"
              onClick={() => onOpenImage(item.url)}
              title={item.name}
            >
              <img src={item.url} alt={item.name} loading="lazy" />
            </button>
          ))}
        </div>
      )}

      {files.length > 0 && (
        <div className="attachments-files">
          {files.map((item) => (
            <a
              key={item.id}
              className="attachment-file"
              href={item.downloadUrl}
              target="_blank"
              rel="noopener noreferrer"
              title={`Скачать ${item.name}`}
            >
              <span className="attachment-file-icon">
                <FileGlyph attachment={item} />
              </span>
              <span className="attachment-file-meta">
                <span className="attachment-file-name">{item.name}</span>
                <span className="attachment-file-size">{formatBytes(item.size)}</span>
              </span>
              <Download size={16} className="attachment-file-dl" />
            </a>
          ))}
        </div>
      )}
    </div>
  )
}
